export const convertUTCDateToLocalDate = (date: Date | string) => {
    var newDate = new Date(date);
    newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());
    return newDate;
}